import { render, staticRenderFns } from "./Chef.vue?vue&type=template&id=0eae40dc"
import script from "./Chef.vue?vue&type=script&lang=js"
export * from "./Chef.vue?vue&type=script&lang=js"
import style0 from "./Chef.vue?vue&type=style&index=0&id=0eae40dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports